import graphqlClient from '@/graphql/graphql-client';
import { eqFromWhere, toListQueryVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';
import {
  TemplateDocxsDocument,
  type TemplateDocxsQuery,
  type TemplateDocxsQueryVariables,
} from '@/graphql/generated/graphql';

export type TemplateDocxRecord = NonNullable<
  NonNullable<TemplateDocxsQuery['getTemplateDocxs']>['items']
>[number];
export type GetTemplateDocxsResponse = TemplateDocxsQuery;

export const toTemplateDocxsVariables = (
  params?: ListQueryVariables<Record<string, unknown>> | null
): TemplateDocxsQueryVariables => {
  const { where, paging } = toListQueryVariables(params);
  return {
    templateId: eqFromWhere(where, 'TemplateId'),
    pageNo: paging.pageNo,
    pageSize: paging.pageSize,
  };
};

export const useGetTemplateDocxs = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toTemplateDocxsVariables(params);
  return useQuery({
    queryKey: ['template-docxs', variables],
    queryFn: () => graphqlClient.request(TemplateDocxsDocument, variables),
  });
};

export const requestTemplateDocxs = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toTemplateDocxsVariables(params);
  return graphqlClient.request(TemplateDocxsDocument, variables);
};

export const GET_TEMPLATE_DOCXS_QUERY = TemplateDocxsDocument;
